<template>
  <v-container class="d-flex flex-column align-center">
    <div class="term" v-if="isTerm">
      <p v-html="message"></p>
      <div class="d-flex justify-end">
        <v-btn class="success" depressed tile @click="submit"> I Agree </v-btn>
      </div>
    </div>
    <div class="term" v-else v-html="message"></div>
  </v-container>
</template>
<script>
import { functions, templates } from "../assets/js/firebase";
import {
  formatMessage,
  getAppointmentWindow,
  getDate
} from "../assets/js/common";
import customerModal from "../assets/js/customer.modal";
export default {
  data() {
    return {
      loading: true,
      message: "",
      unsubscribe: null,
      is_agree: null,
      status: -1
    };
  },
  beforeDestroy() {
    if (this.unsubscribe !== null) this.unsubscribe();
  },
  computed: {
    isTerm() {
      let { is_agree, status } = this;
      if (status == 0 || status == 4) return true;
      return status != 7 && is_agree == false;
    }
  },
  methods: {
    async submit() {
      const vm = this;
      let { id } = vm.$route.params;
      vm.$root.loader = true;
      try {
        let updated_at = getDate();
        await functions.httpsCallable("jobConfirm")({
          id,
          updated_at,
          is_self: false,
        });
        vm.$root.loader = false;
        vm.status = -1;
        vm.message = "";
        vm.init();
      } catch (e) {
        vm.loading = false;
        vm.$root.loader = false;
        vm.$root.alert(e.message);
      }
    },
    async init() {
      const vm = this;
      let { id } = vm.$route.params;
      try {
        vm.$loader.show();
        let { data } = await functions.httpsCallable("getCustomer")({ id });
        vm.$loader.hide();
        if (data.data == null) {
          vm.message = "Job not found";
        } else {
          let doc = data.data;
          let {
            status,
            confirm_url,
            is_agree,
            template_name,
            job_number
          } = doc;
          doc.fields["Job_Confirmation_Link"] = confirm_url;
          doc.fields[
            customerModal.APPOINTMENT_TIME_WINDOW
          ] = getAppointmentWindow(doc);
          doc.fields.Job_Type = template_name;
          doc.fields.Job_Number = job_number;
          vm.status = status;
          vm.is_agree = is_agree;
          if (vm.isTerm) {
            vm.message = formatMessage(doc);
            vm.$root.loader = false;
          } else {
            vm.$root.loader = false;
            vm.getMessage(doc);
          }
        }
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    async getMessage({
      status,
      fields,
      disposition,
      job_number,
      template_name
    }) {
      const vm = this;
      try {
        vm.message = "";
        vm.$root.loader = true;
        let id = "web-job-confirmation-message";
        if (status == 7 && disposition == customerModal.DISPOSITION_CANCEL) {
          id = "web-job-cancellation-message";
        } else if (status == 7) {
          id = "web-job-already-completed";
        }
        let snap = await templates.doc(id).get();
        let { message } = snap.data();
        fields.Job_Type = template_name;
        fields.Job_Number = job_number;
        vm.message = formatMessage({
          message,
          fields,
          options: {},
          template_name,
          job_number
        });
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
.term {
  max-width: 800px;
  padding: 10px;
  p {
    text-align: justify;
    color: #1e1f1f;
    font-weight: 500;
    @media only screen and (max-width: 600px) {
      font-size: 14px;
    }
  }
}
</style>
